import { sharedLib } from "@shared/services/shared.service.ts";
import { OAuthPlatformType, RequestSource } from "@shared/types";
import { useReferralCode } from "features/auth/hooks.ts";
import { useContext } from "react";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context.ts";

interface useSocialLoginsProps {
  openUrl: (url: string) => void;
  isAppSource?: boolean;
}

const useSocialLogins = ({ openUrl, isAppSource }: useSocialLoginsProps) => {
  const { token: externalInviteToken } =
    useContext(ExternalConnectAccountContext) || {};
  const referralCode = useReferralCode();

  const [getLoginAuthUrl] =
    sharedLib.sharedApi.authentication.useLazyGetLoginAuthUrlQuery();

  const onLoginClick = async (
    oauthPlatformType: OAuthPlatformType,
    linkAccount?: boolean
  ) => {
    return getLoginAuthUrl({
      oauth_platform: oauthPlatformType,
      request_source: isAppSource ? RequestSource.APP : RequestSource.WEBSITE,
      referral_code: referralCode,
      client_token: externalInviteToken,
      link_account: linkAccount,
    })
      .then((response) => {
        const url = response.data;
        url && openUrl(url);
      })
      .catch(() => {});
  };

  return {
    onLoginClick,
  };
};

export default useSocialLogins;
